import { Component, OnInit, ViewChild } from "@angular/core";
import { TaskService } from "../../master-services/tasks/task.service";
import { ITaskType } from "../../master-models/task.model";
import swal from "sweetalert2";
import { ModalBasicComponent } from "../../shared/modal-basic/modal-basic.component";

@Component({
  selector: "app-task-types-management",
  templateUrl: "./task-types-management.component.html",
  styleUrls: [
    "./task-types-management.component.scss",
    '../../../assets/icon/icofont/css/icofont.scss'
  ],
})
export class TaskTypesManagementComponent implements OnInit {
  taskTypes: ITaskType[] = [];
  typeIdToEdit: number = 0;
  newType: string = '';

  @ViewChild('modalFormType') modalFormType: ModalBasicComponent;

  constructor(private taskService: TaskService) {}

  ngOnInit() {
    this.getTaskTypes();
  }

  getTaskTypes() {
    this.taskService.getTaskTypes().subscribe(
      (data) => {
        this.taskTypes = data.data;
      },
      (error) => {
        console.log(error);
        swal({
          title: 'Error al obtener los tipos',
          text: 'Ocurrió un error al intentar obtener los tipos',
          type: 'error',
        });
      }
    );
  }

  toggleTypeForm(typeId: number = 0) {
    if (this.modalFormType.visible) {
      this.modalFormType.hide();
      this.newType = '';
      this.typeIdToEdit = 0;
      return;
    }

    this.typeIdToEdit = typeId;
    if (typeId) {
      const type = this.taskTypes.find(t => t.id === typeId);
      if (type) {
        this.newType = type.name;
      }
    }
    this.modalFormType.show();
  }

  createType() {
    swal({
      title: 'Validando información ...',
      allowOutsideClick: false
    });
    swal.showLoading();

    if (!this.newType) {
      swal({
        title: 'Por favor ingrese el nuevo tipo',
        text: 'Debe ingresar una descripcion valida para el tipo',
        type: 'error'
      });
      return;
    }

    const newTypeBody = { name: this.newType };

    this.taskService.createTaskType(newTypeBody)
      .subscribe(
        data => {
          this.getTaskTypes();
          swal({
            title: 'Tipo agregado',
            type: 'success'
          });
          this.toggleTypeForm();
        },
        error => {
          console.log(error);
          swal({
            title: 'Error al agregar el tipo',
            text: 'Ocurrió un error al intentar agregar el nuevo tipo',
            type: 'error'
          });
        }
      );
  }

  updateType() {
    swal({
      title: 'Validando información ...',
      allowOutsideClick: false
    });
    swal.showLoading();

    if (!this.newType) {
      swal({
        title: 'Por favor ingrese el nuevo tipo',
        text: 'Debe ingresar una descripcion valida para el tipo',
        type: 'error'
      });
      return;
    }

    const typeBody = { name: this.newType };

    this.taskService.updateTaskType(this.typeIdToEdit, typeBody)
      .subscribe(
        data => {
          this.getTaskTypes();
          swal({
            title: 'Tipo modificado',
            type: 'success'
          });
          this.toggleTypeForm();
        },
        error => {
          console.log(error);
          swal({
            title: 'Error al modificar el tipo',
            text: 'Ocurrió un error al intentar modificar el tipo',
            type: 'error'
          });
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/master/task-types-management/task-types-management.component.ts